import { Link } from "react-router-dom";

const groups = [
  ["Main", [["Home", "/"], ["About", "/about"], ["Admissions", "/admissions"], ["Academics", "/academics"], ["Contact", "/contact"]]],
  ["Academic Resources", [["Departments", "/departments"], ["Downloads", "/downloads"], ["Staff Directory", "/staff"], ["Research", "/research"], ["Journals", "/journals"]]],
  ["Campus", [["Notice Board", "/notice-board"], ["Campus Map", "/campus-map"], ["Gallery", "/gallery"], ["Virtual Tour", "/virtual-tour"], ["Help Desk", "/help-desk"]]],
  ["Institutional", [["Alumni", "/alumni"], ["Partnerships", "/partnerships"], ["Project Tracker", "/projects"], ["TETFund Projects", "/tetfund-projects"], ["Search", "/search"]]],
];

export default function SitemapPage() {
  return (
    <main className="min-h-screen bg-slate-50 px-4 py-16">
      <section className="mx-auto max-w-6xl">
        <p className="text-sm font-bold uppercase tracking-[0.25em] text-emerald-700">Navigation</p>
        <h1 className="mt-3 text-4xl font-black text-slate-900">Website Sitemap</h1>
        <p className="mt-3 max-w-2xl text-slate-600">Browse major public pages and resources on the Federal Polytechnic Bida website.</p>
        <div className="mt-8 grid gap-5 md:grid-cols-2">
          {groups.map(([title, links]) => (
            <div key={title} className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200">
              <h2 className="text-xl font-black text-slate-900">{title}</h2>
              <div className="mt-4 grid gap-3">
                {links.map(([label, to]) => <Link key={to} to={to} className="rounded-2xl border border-slate-200 p-4 font-bold text-emerald-700 hover:bg-emerald-50">{label}</Link>)}
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
